// DeleteWebhookModal.jsx
import PropTypes from "prop-types";
import GModal from "../../design/components/GModal";
import Button from "../../design/Button";

const DeleteWebhookModal = ({ visible, closeModal, onDelete, webhookName }) => (
  <GModal
    visible={visible}
    heading="Delete webhook"
    closeModal={closeModal}
    bottomButtons={[
      <Button
        key="cancel"
        buttonText="Cancel"
        variant="outlined"
        hierarchy="white"
        onClick={closeModal}
        styleOverride={{width: '75px', height: '36px'}}
      />,
      <Button
        key="delete"
        buttonText="Delete"
        variant="contained"
        hierarchy="red"
        onClick={onDelete}
        styleOverride={{ marginLeft: "8px", width: '72px', height: '36px'}}
      />,
    ]}
    body={
      <div className="t7 color-4a text-center">
        Are you sure you want to delete{" "}
        <strong>{webhookName}</strong>?
      </div>
    }
    headingStyle={{
      fontWeight: "600",
      fontSize: "16px",
    }}
    modalStyle={{
      width: '435px',
      minWidth: '435px', 
      minHeight: 'unset' 
    }}
    bottomButtonsStyle={{
      paddingTop: '4px',
      borderTop: 'none'
    }}
  />
);

DeleteWebhookModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  webhookName: PropTypes.string.isRequired,
};

export default DeleteWebhookModal;
